import { Directive, ElementRef, HostListener, Injectable, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { PageKeyModule, PageKeyService } from '@wdpr/ra-angular-page-key';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from 'ngx-cookie-service';
import * as ɵngcc3 from '@wdpr/ra-angular-page-key';
class ConfigService {
    /**
     * @param {?} http
     */
    constructor(http$$1) {
        this.http = http$$1;
        this.loader = this.defaultLoader;
        this.autoPageViewTrackingTiming = 1000;
        this.globalProcessors = {};
        this.serverHost = '';
        this.serverPath = 'analytics';
    }
    /**
     * @param {?} processors
     * @return {?}
     */
    addGlobalProcessors(processors) {
        return Object.assign(this.globalProcessors, processors);
    }
    /**
     * @param {?} pagekey
     * @return {?}
     */
    defaultLoader(pagekey) {
        return this.http.get(`${this.serverHost}/${this.serverPath}/${pagekey}.json`).toPromise();
    }
}
ConfigService.ɵfac = function ConfigService_Factory(t) { return new (t || ConfigService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
ConfigService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ConfigService, factory: ConfigService.ɵfac });
/**
 * @nocollapse
 */
ConfigService.ctorParameters = () => [
    { type: HttpClient, },
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfigService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class FrameworkService {
    /**
     * @return {?}
     */
    framework() {
        const /** @type {?} */ w = window;
        return this.f || (this.f = w.WDPRO && w.WDPRO.Analytics && w.WDPRO.Analytics.Framework);
    }
}
FrameworkService.ɵfac = function FrameworkService_Factory(t) { return new (t || FrameworkService)(); };
FrameworkService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FrameworkService, factory: FrameworkService.ɵfac });
/**
 * @nocollapse
 */
FrameworkService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FrameworkService, [{
        type: Injectable
    }], null, null); })();

let cookieService;
class GlobalService {
    /**
     * @param {?} config
     * @param {?} cs
     */
    constructor(config, cs) {
        this.config = config;
        this.cs = cs;
        this.properties = {
            customerId: customerId,
            registrationStatus: registrationStatus,
            guestType: guestType,
            events: [
                loggedInOrOutEvent,
                registrationEvent
            ],
            contentLocale: contentLocale,
            contentLanguage: contentLanguage,
            device: {
                type: deviceType,
                viewType: deviceViewType
            },
            configuration: {
                currency: configurationCurrency
            },
            currencyDisplayed: currencyDisplayed
        };
        cookieService = this.cs;
    }
    /**
     * @param {?} model
     * @return {?}
     */
    augment(model) {
        return _meld(_normalizeModel(model), _merge(this.properties, _normalizeModel(this.config.globalProcessors)));
    }
}
GlobalService.ɵfac = function GlobalService_Factory(t) { return new (t || GlobalService)(ɵngcc0.ɵɵinject(ConfigService), ɵngcc0.ɵɵinject(ɵngcc2.CookieService)); };
GlobalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GlobalService, factory: GlobalService.ɵfac });
/**
 * @nocollapse
 */
GlobalService.ctorParameters = () => [
    { type: ConfigService, },
    { type: CookieService, },
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GlobalService, [{
        type: Injectable
    }], function () { return [{ type: ConfigService }, { type: ɵngcc2.CookieService }]; }, null); })();
/**
 * @return {?}
 */
function customerId() {
    return cookieService.get('SWID');
}
/**
 * @param {?} model
 * @return {?}
 */
function registrationStatus(model) {
    const /** @type {?} */ cid = cookieService.get('SWID'), /** @type {?} */ isRegistered = typeof cid === 'string' && cid.substr(0, 1) === '{', /** @type {?} */ isLoggedIn = cookieService.get('authenticationSecure');
    if (isLoggedIn) {
        return 'Registered - Logged In';
    }
    else if (isRegistered) {
        return 'Registered - Not Logged In';
    }
    return 'Not Registered';
}
/**
 * @return {?}
 */
function guestType() {
    return 'Guest';
}
/**
 * @return {?}
 */
function loggedInOrOutEvent() {
    const /** @type {?} */ isLoggedIn = String(!!cookieService.get('authenticationSecure')), /** @type {?} */ storage = verifyStorage(window.sessionStorage);
    let /** @type {?} */ previousState, /** @type {?} */ result;
    if (storage) {
        previousState = storage.getItem('analytics-logged-in-state');
        if (previousState === 'false' && isLoggedIn === 'true') {
            result = 'loggedIn';
        }
        else if (previousState === 'true' && isLoggedIn === 'false') {
            result = 'loggedOut';
        }
        storage.setItem('analytics-logged-in-state', isLoggedIn);
    }
    return result;
}
/**
 * @return {?}
 */
function registrationEvent() {
    // TODO: determine if detecting registration is possible due to registration occuring in PEP
    // if (guestJustRegistered) {
    //     return 'registration';
    // }
}
/**
 * @return {?}
 */
function contentLocale() {
    const /** @type {?} */ cookieLocale = _getCookieLocale();
    let /** @type {?} */ locale;
    if (cookieLocale) {
        locale = cookieLocale.substr(3);
        if (locale !== 'XX') {
            return locale;
        }
    }
}
/**
 * @return {?}
 */
function contentLanguage() {
    const /** @type {?} */ cookieLocale = _getCookieLocale();
    if (cookieLocale) {
        return cookieLocale.substr(0, 2);
    }
}
/**
 * @return {?}
 */
function deviceType() {
    const /** @type {?} */ WDPROView = getCookieObject('WDPROView');
    return (WDPROView && WDPROView.deviceInfo && WDPROView.deviceInfo.device) ||
        (WDPROView && WDPROView.preferred && WDPROView.preferred.device) ||
        'desktop';
}
/**
 * @return {?}
 */
function deviceViewType() {
    const /** @type {?} */ WDPROView = getCookieObject('WDPROView');
    return (WDPROView && WDPROView.preferred && WDPROView.preferred.device) || 'desktop';
}
/**
 * @return {?}
 */
function configurationCurrency() {
    const /** @type {?} */ localeCookie = getCookieObject('localeCookie_jar');
    return localeCookie && localeCookie.localeCurrency;
}
/**
 * @return {?}
 */
function currencyDisplayed() {
    return configurationCurrency();
}
/**
 * @param {?} name
 * @return {?}
 */
function getCookieObject(name) {
    try {
        return JSON.parse(cookieService.get(name));
    }
    catch (ignore) { }
    return {};
}
/**
 * @param {?} storage
 * @return {?}
 */
function verifyStorage(storage) {
    const /** @type {?} */ k = 'test', /** @type {?} */ v = 'yes';
    try {
        storage.setItem(k, v);
        if (storage.getItem(k) !== v) {
            return false;
        }
        storage.removeItem(k);
    }
    catch (e) {
        return false;
    }
    return storage;
}
/**
 * @return {?}
 */
function _getCookieLocale() {
    const /** @type {?} */ localeCookie = getCookieObject('localeCookie_jar');
    let /** @type {?} */ value;
    if (localeCookie) {
        value = localeCookie.preferredRegion || localeCookie.contentLocale;
        if (typeof value === 'string') {
            if (value.length === 5) {
                if (value[2] === '_' || value[2] === '-') {
                    return value;
                }
            }
            else if (value.length === 2) {
                return value + '_XX';
            }
        }
    }
}
/**
 * @param {?} target
 * @param {?} source
 * @return {?}
 */
function _merge(target, source) {
    let /** @type {?} */ key, /** @type {?} */ k, /** @type {?} */ keysLength, /** @type {?} */ value, /** @type {?} */ valueType;
    const /** @type {?} */ keys = Object.keys(source);
    for (k = 0, keysLength = keys.length; k < keysLength; k++) {
        key = keys[k];
        value = source[key];
        valueType = _type(value);
        switch (valueType) {
            case 'object':
                if (_type(target[key]) !== 'object') {
                    target[key] = {};
                }
                _merge(target[key], value);
                break;
            case 'array':
                if (_type(target[key]) !== 'array') {
                    target[key] = [];
                }
                target[key].push.apply(target[key], value);
                break;
            default:
                target[key] = value;
        }
    }
    return target;
}
/**
 * @param {?} model
 * @return {?}
 */
function _normalizeModel(model) {
    if (model && model.events && typeof model.events === 'string') {
        model.events = model.events.split(',');
    }
    return model;
}
/**
 * @param {?} o
 * @return {?}
 */
function _type(o) {
    const /** @type {?} */ type = typeof o;
    if (type === 'object') {
        if (o === null) {
            return 'null';
        }
        else if (Array.isArray(o)) {
            return 'array';
        }
    }
    return type;
}
/**
 * @param {?} model
 * @param {?} properties
 * @return {?}
 */
function _meld(model, properties) {
    return _merge(model, m(properties) || {});
    /**
     * @param {?} value
     * @return {?}
     */
    function m(value) {
        let /** @type {?} */ replacement, /** @type {?} */ key, /** @type {?} */ k, /** @type {?} */ keysLength, /** @type {?} */ keys;
        switch (_type(value)) {
            case 'object':
                replacement = {};
                keys = Object.keys(value);
                for (k = 0, keysLength = keys.length; k < keysLength; k++) {
                    key = keys[k];
                    const /** @type {?} */ val = m(value[key]);
                    if (val !== undefined) {
                        replacement[key] = val;
                    }
                }
                return Object.keys(replacement).length ? replacement : undefined;
            case 'array':
                replacement = value.map(m).filter(v => v !== undefined);
                return replacement.length ? replacement : undefined;
            case 'function':
                return m(value(model));
            default:
                return value;
        }
    }
}

class AnalyticsService {
    /**
     * @param {?} config
     * @param {?} global
     * @param {?} frameworkService
     * @param {?} pageKeyService
     */
    constructor(config, global, frameworkService, pageKeyService) {
        this.config = config;
        this.global = global;
        this.frameworkService = frameworkService;
        this.pageKeyService = pageKeyService;
        this.framework = this.frameworkService.framework();
        this.pageKeySubscribe();
    }
    /**
     * @return {?}
     */
    update() {
        if (this.framework) {
            this.getModel().then(model => {
                this.framework.reset();
                this.framework.update(model);
            });
        }
    }
    /**
     * @return {?}
     */
    getModel() {
        this.cancelAutoPageTracking();
        return this.modelPromise || (this.modelPromise = Promise.resolve(this.config.loader(this.pageKey))
            .then(validateModel)
            .then(this.global.augment.bind(this.global)));
    }
    /**
     * @param {?} model
     * @return {?}
     */
    trackElement(model) {
        if (this.framework && model.linkId) {
            this.framework.trackElement(model.linkId, model);
        }
    }
    /**
     * @param {?} model
     * @return {?}
     */
    trackPage(model) {
        if (this.framework && model.linkId && model.pageId) {
            this.framework.trackElement(Object.assign(model, { trackingType: 'customPage' }));
        }
    }
    /**
     * @param {?} model
     * @return {?}
     */
    trackLink(model) {
        if (this.framework && model.linkId) {
            this.framework.trackElement(Object.assign(model, { trackingType: 'customLink' }));
        }
    }
    /**
     * @return {?}
     */
    pageKeySubscribe() {
        this.pageKeyService.subscribe(pageKey => this.scheduleAutoPageTracking(pageKey.key));
    }
    /**
     * @return {?}
     */
    cancelAutoPageTracking() {
        clearTimeout(this.timerId);
    }
    /**
     * @param {?} pageKey
     * @return {?}
     */
    scheduleAutoPageTracking(pageKey) {
        this.pageKey = pageKey;
        this.modelPromise = undefined;
        this.cancelAutoPageTracking();
        this.timerId = (setTimeout(this.update.bind(this), this.config.autoPageViewTrackingTiming));
    }
}
AnalyticsService.ɵfac = function AnalyticsService_Factory(t) { return new (t || AnalyticsService)(ɵngcc0.ɵɵinject(ConfigService), ɵngcc0.ɵɵinject(GlobalService), ɵngcc0.ɵɵinject(FrameworkService), ɵngcc0.ɵɵinject(ɵngcc3.PageKeyService)); };
AnalyticsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AnalyticsService, factory: AnalyticsService.ɵfac });
/**
 * @nocollapse
 */
AnalyticsService.ctorParameters = () => [
    { type: ConfigService, },
    { type: GlobalService, },
    { type: FrameworkService, },
    { type: PageKeyService, },
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnalyticsService, [{
        type: Injectable
    }], function () { return [{ type: ConfigService }, { type: GlobalService }, { type: FrameworkService }, { type: ɵngcc3.PageKeyService }]; }, null); })();
/**
 * @param {?} m
 * @return {?}
 */
function validateModel(m) {
    return (typeof m === 'object' && m !== null && !Array.isArray(m)) ? m : Promise.reject('No valid semantic analytics model.');
}

/**
 * @param {?} inputStr
 * @return {?}
 */
function directiveModel(inputStr) {
    if (!inputStr)
        return;
    let /** @type {?} */ val = inputStr;
    try {
        val = decodeURIComponent(val);
    }
    catch (ignore) {
        // ignore
    }
    if (val.includes('{')) {
        try {
            val = JSON.parse(val);
        }
        catch (ignore) {
            // ignore
        }
    }
    if (typeof val === 'string') {
        val = {
            linkId: val
        };
    }
    return val;
}

class TrackPageDirective {
    /**
     * @param {?} analyticsService
     */
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
    }
    /**
     * @return {?}
     */
    click() {
        let /** @type {?} */ val = directiveModel(this.model);
        if (val)
            this.analyticsService.trackPage(val);
    }
}
TrackPageDirective.ɵfac = function TrackPageDirective_Factory(t) { return new (t || TrackPageDirective)(ɵngcc0.ɵɵdirectiveInject(AnalyticsService)); };
TrackPageDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TrackPageDirective, selectors: [["", "analyticsTrackPage", ""]], hostBindings: function TrackPageDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function TrackPageDirective_click_HostBindingHandler() { return ctx.click(); });
    } }, inputs: { model: ["analyticsTrackPage", "model"] } });
/**
 * @nocollapse
 */
TrackPageDirective.ctorParameters = () => [
    { type: AnalyticsService, },
];
TrackPageDirective.propDecorators = {
    'model': [{ type: Input, args: ['analyticsTrackPage',] },],
    'click': [{ type: HostListener, args: ['click',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackPageDirective, [{
        type: Directive,
        args: [{
                selector: '[analyticsTrackPage]'
            }]
    }], function () { return [{ type: AnalyticsService }]; }, { 
    /**
     * @return {?}
     */
    click: [{
            type: HostListener,
            args: ['click']
        }], model: [{
            type: Input,
            args: ['analyticsTrackPage']
        }] }); })();

class TrackLinkDirective {
    /**
     * @param {?} analyticsService
     */
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
    }
    /**
     * @return {?}
     */
    click() {
        let /** @type {?} */ val = directiveModel(this.model);
        if (val)
            this.analyticsService.trackLink(val);
    }
}
TrackLinkDirective.ɵfac = function TrackLinkDirective_Factory(t) { return new (t || TrackLinkDirective)(ɵngcc0.ɵɵdirectiveInject(AnalyticsService)); };
TrackLinkDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TrackLinkDirective, selectors: [["", "analyticsTrackLink", ""]], hostBindings: function TrackLinkDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function TrackLinkDirective_click_HostBindingHandler() { return ctx.click(); });
    } }, inputs: { model: ["analyticsTrackLink", "model"] } });
/**
 * @nocollapse
 */
TrackLinkDirective.ctorParameters = () => [
    { type: AnalyticsService, },
];
TrackLinkDirective.propDecorators = {
    'model': [{ type: Input, args: ['analyticsTrackLink',] },],
    'click': [{ type: HostListener, args: ['click',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackLinkDirective, [{
        type: Directive,
        args: [{
                selector: '[analyticsTrackLink]'
            }]
    }], function () { return [{ type: AnalyticsService }]; }, { 
    /**
     * @return {?}
     */
    click: [{
            type: HostListener,
            args: ['click']
        }], model: [{
            type: Input,
            args: ['analyticsTrackLink']
        }] }); })();

class TrackHoverDirective {
    /**
     * @param {?} analyticsService
     */
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
    }
    /**
     * @return {?}
     */
    mouseenter() {
        let /** @type {?} */ val = directiveModel(this.model);
        if (val)
            this.analyticsService.trackLink(val);
    }
}
TrackHoverDirective.ɵfac = function TrackHoverDirective_Factory(t) { return new (t || TrackHoverDirective)(ɵngcc0.ɵɵdirectiveInject(AnalyticsService)); };
TrackHoverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TrackHoverDirective, selectors: [["", "analyticsTrackHover", ""]], hostBindings: function TrackHoverDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function TrackHoverDirective_mouseenter_HostBindingHandler() { return ctx.mouseenter(); });
    } }, inputs: { model: ["analyticsTrackHover", "model"] } });
/**
 * @nocollapse
 */
TrackHoverDirective.ctorParameters = () => [
    { type: AnalyticsService, },
];
TrackHoverDirective.propDecorators = {
    'model': [{ type: Input, args: ['analyticsTrackHover',] },],
    'mouseenter': [{ type: HostListener, args: ['mouseenter',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackHoverDirective, [{
        type: Directive,
        args: [{
                selector: '[analyticsTrackHover]'
            }]
    }], function () { return [{ type: AnalyticsService }]; }, { 
    /**
     * @return {?}
     */
    mouseenter: [{
            type: HostListener,
            args: ['mouseenter']
        }], model: [{
            type: Input,
            args: ['analyticsTrackHover']
        }] }); })();

class TrackSeenDirective {
    /**
     * @param {?} _analyticsService
     * @param {?} _elementRef
     */
    constructor(_analyticsService, _elementRef) {
        this._analyticsService = _analyticsService;
        this._elementRef = _elementRef;
        this._element = this._elementRef.nativeElement;
        this._trackingFired = false;
        this._throttledChecker = this._throttle(this._checkAndFireTrackElement, 250);
    }
    /**
     * @return {?}
     */
    onWindowEvent() {
        this._throttledChecker();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this._throttledChecker();
    }
    /**
     * @return {?}
     */
    _checkAndFireTrackElement() {
        if (!this._trackingFired && this._isElementVisible(this._element)) {
            this._fireTracking(directiveModel(this.model));
        }
    }
    /**
     * @param {?} element
     * @return {?}
     */
    _isElementVisible(element) {
        let /** @type {?} */ VISIBLE_MARGIN = 1, /** @type {?} */ hasRects = !!element.getClientRects().length, /** @type {?} */ result = hasRects, /** @type {?} */ rect;
        if (hasRects) {
            rect = element.getBoundingClientRect();
            result = !(rect.top > window.innerHeight - VISIBLE_MARGIN ||
                rect.bottom < VISIBLE_MARGIN);
        }
        return result;
    }
    /**
     * @param {?} model
     * @return {?}
     */
    _fireTracking(model) {
        this._analyticsService.trackElement(model);
        this._trackingFired = true;
    }
    /**
     * @param {?} originalFunction
     * @param {?} throttleInterval
     * @return {?}
     */
    _throttle(originalFunction, throttleInterval) {
        let /** @type {?} */ timerId, /** @type {?} */ callContext, /** @type {?} */ callArguments, /** @type {?} */ nextEligibleCallTime = Date.now(), /** @type {?} */ cachedReturn;
        return function () {
            let /** @type {?} */ now;
            callContext = this;
            callArguments = arguments;
            if (timerId) {
                return cachedReturn;
            }
            now = Date.now();
            if (now < nextEligibleCallTime) {
                timerId = setTimeout(executeOriginalFunction, nextEligibleCallTime - now);
                return cachedReturn;
            }
            else {
                return executeOriginalFunction(now);
            }
        };
        /**
         * @param {?} now
         * @return {?}
         */
        function executeOriginalFunction(now) {
            timerId = 0;
            nextEligibleCallTime = (now || Date.now()) + throttleInterval;
            cachedReturn = originalFunction.apply(callContext, callArguments);
            return cachedReturn;
        }
    }
}
TrackSeenDirective.ɵfac = function TrackSeenDirective_Factory(t) { return new (t || TrackSeenDirective)(ɵngcc0.ɵɵdirectiveInject(AnalyticsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TrackSeenDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TrackSeenDirective, selectors: [["", "analyticsTrackSeen", ""]], hostBindings: function TrackSeenDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function TrackSeenDirective_resize_HostBindingHandler() { return ctx.onWindowEvent(); }, false, ɵngcc0.ɵɵresolveWindow)("scroll", function TrackSeenDirective_scroll_HostBindingHandler() { return ctx.onWindowEvent(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { model: ["analyticsTrackSeen", "model"] } });
/**
 * @nocollapse
 */
TrackSeenDirective.ctorParameters = () => [
    { type: AnalyticsService, },
    { type: ElementRef, },
];
TrackSeenDirective.propDecorators = {
    'model': [{ type: Input, args: ['analyticsTrackSeen',] },],
    'onWindowEvent': [{ type: HostListener, args: ['window:resize',] }, { type: HostListener, args: ['window:scroll',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackSeenDirective, [{
        type: Directive,
        args: [{
                selector: '[analyticsTrackSeen]'
            }]
    }], function () { return [{ type: AnalyticsService }, { type: ɵngcc0.ElementRef }]; }, { 
    /**
     * @return {?}
     */
    onWindowEvent: [{
            type: HostListener,
            args: ['window:resize']
        }, {
            type: HostListener,
            args: ['window:scroll']
        }], model: [{
            type: Input,
            args: ['analyticsTrackSeen']
        }] }); })();

class AnalyticsModule {
}
AnalyticsModule.ɵfac = function AnalyticsModule_Factory(t) { return new (t || AnalyticsModule)(); };
AnalyticsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AnalyticsModule });
AnalyticsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        AnalyticsService,
        ConfigService,
        FrameworkService,
        GlobalService,
        CookieService
    ], imports: [CommonModule,
        HttpClientModule,
        PageKeyModule] });
/**
 * @nocollapse
 */
AnalyticsModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnalyticsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule,
                    PageKeyModule
                ],
                providers: [
                    AnalyticsService,
                    ConfigService,
                    FrameworkService,
                    GlobalService,
                    CookieService
                ],
                declarations: [
                    TrackPageDirective,
                    TrackLinkDirective,
                    TrackHoverDirective,
                    TrackSeenDirective
                ],
                exports: [
                    TrackPageDirective,
                    TrackLinkDirective,
                    TrackHoverDirective,
                    TrackSeenDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AnalyticsModule, { declarations: function () { return [TrackPageDirective, TrackLinkDirective, TrackHoverDirective, TrackSeenDirective]; }, imports: function () { return [CommonModule,
        HttpClientModule,
        PageKeyModule]; }, exports: function () { return [TrackPageDirective, TrackLinkDirective, TrackHoverDirective, TrackSeenDirective]; } }); })();

// All modules should be listed here

/**
 * Generated bundle index. Do not edit.
 */

export { AnalyticsModule, AnalyticsService, ConfigService, FrameworkService, GlobalService, TrackHoverDirective, TrackLinkDirective, TrackPageDirective, TrackSeenDirective };

